import React from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

export interface WallpaperCalculatorResult {
  rolls: number;
  waste: number;
  coveringsPerRoll: number;
  totalCoverings: number;
  showWaste: boolean;
}

const WallpaperCalculatorResult = ({
  rolls,
  waste,
  coveringsPerRoll,
  totalCoverings,
  showWaste,
}: WallpaperCalculatorResult) => {
  return (
    <div className="grid grid-cols-1 gap-3">
      <div className="flex items-center gap-2">
        <Icon name="check" className="h-6 w-6 flex-shrink-0" />
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              'wallpaper-calculator.result.total-coverings'
            ).replace('{coverings}', totalCoverings.toString()),
          }}
        ></span>
      </div>
      <div className="flex items-center gap-2">
        <Icon name="check" className="h-6 w-6 flex-shrink-0" />
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              'wallpaper-calculator.result.coverings'
            ).replace('{coverings}', coveringsPerRoll.toString()),
          }}
        ></span>
      </div>
      {showWaste && (
        <div className="flex items-center gap-2">
          <Icon name="check" className="h-6 w-6 flex-shrink-0" />
          <span
            dangerouslySetInnerHTML={{
              __html: translate(
                'wallpaper-calculator.result.cutting-margin'
              ).replace('{waste}', Math.floor(waste * 100).toString()),
            }}
          ></span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <Icon name="check" className="h-6 w-6 flex-shrink-0" />
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              'wallpaper-calculator.result.recommendation'
            ).replace('{rolls}', rolls.toString()),
          }}
        ></span>
      </div>
    </div>
  );
};

export default WallpaperCalculatorResult;
